import React from "react";
import Modal from "../../Modal.tsx";
import SamButton from "../../SamButton.tsx";
import {SelectedComp} from "../fields/configurablecompsselect/configurableCompsSelectTypes.tsx";

interface ConfirmDeleteComparableModalProps {
    isOpen: boolean;
    handleModalClose: (confirmed: boolean) => void;
    slot?: SelectedComp;
}

export const ConfirmDeleteComparableModal: React.FC<ConfirmDeleteComparableModalProps> = ({
                                                                                              isOpen,
                                                                                              handleModalClose,
                                                                                              slot
                                                                                          }) => {
    if (!isOpen) return null;


    return (
        <Modal
            isOpen={isOpen}
            onClose={() => handleModalClose(false)}
            title={"Delete Comparable?"}
        >
            {slot &&
                <>
                    <div className="flex flex-col space-y-1 mb-3">
                        <label className="text-sm font-medium text-gray-700">Are you sure you want to delete <br/>{slot.address}<br/>from {slot.dgInfo?.requiredType} Slot {slot.indexOfDg + 1}?</label>
                    </div>

                    <div className="flex justify-between">
                        <SamButton onClick={() => handleModalClose(false)}>Cancel</SamButton>
                        <SamButton onClick={() => handleModalClose(true)}>Confirm Delete</SamButton>
                    </div>
                </>
            }
        </Modal>
    );
};